/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Faq_2_QuestionInputs */

const en_svc_agents_faq_2_question = /** @type {(inputs: Svc_Agents_Faq_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can an AI agent work with our CRM and email?`)
};

const lv_svc_agents_faq_2_question = /** @type {(inputs: Svc_Agents_Faq_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai AI aģents var strādāt ar mūsu CRM un e-pastu?`)
};

/**
* | output |
* | --- |
* | "Can an AI agent work with our CRM and email?" |
*
* @param {Svc_Agents_Faq_2_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_faq_2_question = /** @type {((inputs?: Svc_Agents_Faq_2_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Faq_2_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_faq_2_question(inputs)
	return en_svc_agents_faq_2_question(inputs)
});